import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import isWeekend from 'date-fns/isWeekend';

import { DayPicker, TimePicker } from 'datepicker-wrap';
import { FormLabel as Label, RadioButtons, Gap } from '~ui-kit';
// import Textarea from './Textarea';
import OpenHours from './OpenHours';

import { combineDateAndTime } from '../../helpers';
import { fetchScheduleOptions, getTimeInfo } from '~services/api.helpers';

const strings = {
  NORMAALI: 'Normaali',
  PIKA: 'Nopea',
  MAARATTY: 'Myöhemmin sovittuna ajankohtana',
};

const getDateString = rawDate => {
  const date = moment(rawDate);
  let s = '';

  const today = moment().endOf('day');
  const tomorrow = moment().add(1, 'day').endOf('day');

  if (date < today) s = `tänään klo ${date.format('HH.mm')}`;
  else if (date < tomorrow) s = `huomenna klo ${date.format('HH.mm')}`;
  else s = `${date.format('dddd[na klo] HH.mm')}`;

  return `Viimeistään ${s}`;
};

const DeliveryTime = ({
  formId,
  onChange,
  value,
  required,
  label,
  showOpenHours,
  meta,
}) => {
  const [scheduleOptions, setScheduleOptions] = useState([]);
  const [timeInfo, setTimeInfo] = useState();

  const laterSchedule =
    scheduleOptions.find(o => o.scheduleType === 'MAARATTY') || {};
  const { startDate, endDate } = laterSchedule;
  const scheduleType = value?.scheduleType;
  const earliestTime = value?.earliestTime;
  const latestTime = value?.latestTime;

  useEffect(() => {
    const update = async () => {
      const res = await fetchScheduleOptions(formId);
      // The API returns an object, so let's strip it
      // Filter out nulls as well
      const opts = Object.values(res).filter(o => o);
      setScheduleOptions(opts);

      // Copypasta from above, but I think it's fine
      const laterSchedule = opts.find(o => o.scheduleType === 'MAARATTY') || {};
      const { startDate, endDate } = laterSchedule;
      // Change defaults value to whatever the schedule allows
      onChange({
        ...value,
        earliestTime: moment(startDate),
        latestTime: moment(endDate),
      });
    };

    try {
      update();
    } catch (e) {
      console.error('Error in DeliveryTime', e);
    }
  }, []);

  useEffect(() => {
    const updateTimeInfo = async time => {
      // TODO This isn't working
      const tempTimeInfo = await getTimeInfo(formId, {
        scheduleType,
        time,
      });
      setTimeInfo(tempTimeInfo);
    };

    if (showOpenHours && scheduleType && formId) {
      const time = earliestTime || moment();
      updateTimeInfo(time.toISOString());
    }
  }, [scheduleType, earliestTime, formId, showOpenHours]);

  return (
    <Wrapper>
      <Label required={required}>{label || 'Valitse toimitusaika'}</Label>
      <RadioButtons
        options={scheduleOptions.map(o => ({
          value: o.scheduleType,
          label: `${strings[o.scheduleType]}${
            o.scheduleType !== 'MAARATTY' ? `: ${getDateString(o.details)}` : ''
          } ${
            o.scheduleType === 'PIKA' || o.scheduleType === 'MAARATTY'
              ? '(sis. lisäkustannus)'
              : ''
          }`,
        }))}
        onChange={newValue => onChange({ ...value, scheduleType: newValue })}
        value={scheduleType}
      />
      {scheduleType === 'MAARATTY' && (
        <Later>
          <EarliestLatest>
            <div>
              <Label>Päivämäärä</Label>
              <DayPicker
                selected={latestTime}
                onChange={newValue =>
                  onChange({
                    ...value,
                    latestTime: combineDateAndTime(newValue, latestTime),
                    earliestTime: combineDateAndTime(newValue, earliestTime),
                  })
                }
                dateFormat="dd.MM.yyyy"
                filterDate={date =>
                  !isWeekend(date) &&
                  date > moment(startDate).subtract(1, 'day')
                }
              />
            </div>
            <TimeControls>
              <div>
                <Label>Aikaisintaan</Label>
                <TimePicker
                  selected={earliestTime}
                  onChange={newValue =>
                    onChange({ ...value, earliestTime: newValue })
                  }
                  width="100px"
                  showTimeSelect
                  dateFormat="HH.mm"
                  timeFormat="HH.mm"
                  showTimeSelectOnly
                  timeIntervals={30}
                  minTime={moment(startDate)}
                  maxTime={moment(endDate)}
                  invalid={meta.error}
                />
              </div>
              <div>
                <Label>Viimeistään</Label>
                <TimePicker
                  selected={latestTime}
                  onChange={newValue =>
                    onChange({ ...value, latestTime: newValue })
                  }
                  width="100px"
                  showTimeSelect
                  dateFormat="HH.mm"
                  timeFormat="HH.mm"
                  showTimeSelectOnly
                  timeIntervals={30}
                  minTime={moment(startDate)}
                  maxTime={moment(endDate)}
                  invalid={meta.error}
                />
              </div>
            </TimeControls>
          </EarliestLatest>
          {/* <Label htmlFor="pickupAddress">
            Lisätietoja kuljetukseen liittyen
          </Label>
          <Textarea
            id="pickupAddress"
            value={value?.pickupAddress}
            placeholder={placeholder}
            onChange={event =>
              onChange({ ...value, pickupAddress: event.target.value })
            }
          /> */}
        </Later>
      )}
      {showOpenHours && timeInfo && (
        <>
          <Gap height="24px" />
          <OpenHours timeInfo={timeInfo} />
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  font-size: 16px;
`;

const Later = styled.div`
  margin-top: 16px;
`;

const EarliestLatest = styled.div`
  margin-top: 24px;
  // margin-bottom: 24px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const TimeControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export default DeliveryTime;
